import { useTranslation } from "react-i18next";

const HowItWorks = () => {
  const { t } = useTranslation();

  // SVG Icons for participants
  const BusinessIcon = () => (
    <svg
      className="w-12 h-12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <rect
        x="3"
        y="6"
        width="18"
        height="12"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10h4M7 14h2M15 10h2M15 14h2"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect x="9" y="18" width="1" height="2" fill="currentColor" />
      <rect x="14" y="18" width="1" height="2" fill="currentColor" />
    </svg>
  );

  const IdeaIcon = () => (
    <svg
      className="w-12 h-12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <circle cx="12" cy="12" r="5" strokeWidth="2" />
      <path
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  const TechIcon = () => (
    <svg
      className="w-12 h-12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <circle cx="12" cy="12" r="3" strokeWidth="2" />
      <path
        d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M9 15l6-6M15 15l-6-6" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );

  const DesignIcon = () => (
    <svg
      className="w-12 h-12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <rect
        x="3"
        y="3"
        width="7"
        height="7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="3"
        width="7"
        height="7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="14"
        width="7"
        height="7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3"
        y="14"
        width="7"
        height="7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const RocketIcon = () => (
    <svg
      className="w-10 h-10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <path
        d="M12 2C12 2 8 6 8 12c0 2.21 1.79 4 4 4s4-1.79 4-4c0-6-4-10-4-10z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16v6M8 22l4-2 4 2M5 14l2 2M19 14l-2 2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="10" r="1.5" fill="currentColor" />
    </svg>
  );

  const DrawingIcon = () => (
    <svg
      className="w-10 h-10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2" />
      <path d="M3 9h18M9 21V9" strokeWidth="2" strokeLinecap="round" />
      <circle cx="6" cy="6" r="1" fill="currentColor" />
      <path
        d="M12 13l2 2 4-4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const ChartIcon = () => (
    <svg
      className="w-10 h-10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <path
        d="M3 3v18h18"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 16V8M12 16v-6M17 16v-4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="6"
        y="8"
        width="2"
        height="8"
        fill="currentColor"
        opacity="0.3"
      />
      <rect
        x="11"
        y="10"
        width="2"
        height="6"
        fill="currentColor"
        opacity="0.3"
      />
      <rect
        x="16"
        y="12"
        width="2"
        height="4"
        fill="currentColor"
        opacity="0.3"
      />
    </svg>
  );

  const DocIcon = () => (
    <svg
      className="w-10 h-10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <circle cx="12" cy="12" r="3" strokeWidth="2" />
      <path
        d="M12 2v3M12 19v3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M2 12h3M19 12h3M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );

  const CentralNeuralIcon = () => (
    <svg className="w-24 h-24" viewBox="0 0 100 100" fill="none">
      <circle cx="50" cy="50" r="12" fill="currentColor" opacity="0.9" />
      <circle cx="50" cy="20" r="5" fill="currentColor" opacity="0.8" />
      <circle cx="71" cy="29" r="5" fill="currentColor" opacity="0.8" />
      <circle cx="80" cy="50" r="5" fill="currentColor" opacity="0.8" />
      <circle cx="71" cy="71" r="5" fill="currentColor" opacity="0.8" />
      <circle cx="50" cy="80" r="5" fill="currentColor" opacity="0.8" />
      <circle cx="29" cy="71" r="5" fill="currentColor" opacity="0.8" />
      <circle cx="20" cy="50" r="5" fill="currentColor" opacity="0.8" />
      <circle cx="29" cy="29" r="5" fill="currentColor" opacity="0.8" />
      <line
        x1="50"
        y1="50"
        x2="50"
        y2="20"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
      <line
        x1="50"
        y1="50"
        x2="71"
        y2="29"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
      <line
        x1="50"
        y1="50"
        x2="80"
        y2="50"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
      <line
        x1="50"
        y1="50"
        x2="71"
        y2="71"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
      <line
        x1="50"
        y1="50"
        x2="50"
        y2="80"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
      <line
        x1="50"
        y1="50"
        x2="29"
        y2="71"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
      <line
        x1="50"
        y1="50"
        x2="20"
        y2="50"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
      <line
        x1="50"
        y1="50"
        x2="29"
        y2="29"
        stroke="currentColor"
        strokeWidth="2"
        opacity="0.6"
      />
    </svg>
  );

  return (
    <section id="how-it-works" className="py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="text-center mb-20 animate-fade-in">
          <h2 className="text-4xl md:text-6xl font-bold mb-6 gradient-text">
            {t("howItWorks.title")}
          </h2>
          <p className="text-xl md:text-2xl text-neuro-cyan/80">
            {t("howItWorks.subtitle")}
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto glass-neuro p-8 md:p-12 rounded-3xl shadow-[0_0_60px_rgba(0,245,212,0.15)] border-2 border-neuro-cyan/30 animate-fade-in">
          <div className="relative max-w-5xl mx-auto">
            <div className="text-center">
              <h3 className="text-2xl md:text-3xl font-bold mb-4 gradient-text">
                {t("howItWorks.collective.subtitle")}
              </h3>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
              {/* Participant 1 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "0s" }}
              >
                <div className="relative mb-4 w-32 h-32">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 120 138"
                    fill="none"
                  >
                    <path
                      d="M60 0 L120 34.5 L120 103.5 L60 138 L0 103.5 L0 34.5 Z"
                      className="stroke-neuro-cyan/50 group-hover:stroke-neuro-cyan transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon-avatar w-32 h-32 bg-gradient-to-br from-neuro-cyan/10 to-neuro-cyan/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(0,245,212,0.5),inset_0_0_30px_rgba(0,245,212,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(0,245,212,0.2)] backdrop-blur-sm">
                    <svg
                      className="w-16 h-16 text-neuro-cyan/60 group-hover:text-neuro-cyan transition-colors"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M12 14c-5 0-8 2.5-8 5v2h16v-2c0-2.5-3-5-8-5z" />
                    </svg>
                    <div className="absolute inset-0 bg-neuro-cyan/0 group-hover:bg-neuro-cyan/10 transition-all duration-300"></div>
                  </div>
                </div>
                <div className="text-center">
                  <div className="flex justify-center mb-2 text-neuro-cyan group-hover:scale-110 transition-transform">
                    <BusinessIcon />
                  </div>
                  <p className="text-sm text-gray-400 group-hover:text-neuro-cyan transition-colors">
                    {t("howItWorks.participants.business")}
                  </p>
                </div>
              </div>

              {/* Participant 2 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "0.5s" }}
              >
                <div className="relative mb-4 w-32 h-32">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 120 138"
                    fill="none"
                  >
                    <path
                      d="M60 0 L120 34.5 L120 103.5 L60 138 L0 103.5 L0 34.5 Z"
                      className="stroke-neuro-purple/50 group-hover:stroke-neuro-purple transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon-avatar w-32 h-32 bg-gradient-to-br from-neuro-purple/10 to-neuro-purple/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(138,46,255,0.5),inset_0_0_30px_rgba(138,46,255,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(138,46,255,0.2)] backdrop-blur-sm">
                    <svg
                      className="w-16 h-16 text-neuro-purple/60 group-hover:text-neuro-purple transition-colors"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M12 14c-5 0-8 2.5-8 5v2h16v-2c0-2.5-3-5-8-5z" />
                    </svg>
                    <div className="absolute inset-0 bg-neuro-purple/0 group-hover:bg-neuro-purple/10 transition-all duration-300"></div>
                  </div>
                </div>
                <div className="text-center">
                  <div className="flex justify-center mb-2 text-neuro-purple group-hover:scale-110 transition-transform">
                    <IdeaIcon />
                  </div>
                  <p className="text-sm text-gray-400 group-hover:text-neuro-purple transition-colors">
                    {t("howItWorks.participants.creative")}
                  </p>
                </div>
              </div>

              {/* Participant 3 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "1s" }}
              >
                <div className="relative mb-4 w-32 h-32">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 120 138"
                    fill="none"
                  >
                    <path
                      d="M60 0 L120 34.5 L120 103.5 L60 138 L0 103.5 L0 34.5 Z"
                      className="stroke-neuro-azure/50 group-hover:stroke-neuro-azure transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon-avatar w-32 h-32 bg-gradient-to-br from-neuro-azure/10 to-neuro-azure/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(79,225,255,0.5),inset_0_0_30px_rgba(79,225,255,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(79,225,255,0.2)] backdrop-blur-sm">
                    <svg
                      className="w-16 h-16 text-neuro-azure/60 group-hover:text-neuro-azure transition-colors"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M12 14c-5 0-8 2.5-8 5v2h16v-2c0-2.5-3-5-8-5z" />
                    </svg>
                    <div className="absolute inset-0 bg-neuro-azure/0 group-hover:bg-neuro-azure/10 transition-all duration-300"></div>
                  </div>
                </div>
                <div className="text-center">
                  <div className="flex justify-center mb-2 text-neuro-azure group-hover:scale-110 transition-transform">
                    <TechIcon />
                  </div>
                  <p className="text-sm text-gray-400 group-hover:text-neuro-azure transition-colors">
                    {t("howItWorks.participants.technical")}
                  </p>
                </div>
              </div>

              {/* Participant 4 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "1.5s" }}
              >
                <div className="relative mb-4 w-32 h-32">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 120 138"
                    fill="none"
                  >
                    <path
                      d="M60 0 L120 34.5 L120 103.5 L60 138 L0 103.5 L0 34.5 Z"
                      className="stroke-neuro-cyan/50 group-hover:stroke-neuro-cyan transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon-avatar w-32 h-32 bg-gradient-to-br from-neuro-cyan/10 to-neuro-cyan/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(0,245,212,0.5),inset_0_0_30px_rgba(0,245,212,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(0,245,212,0.2)] backdrop-blur-sm">
                    <svg
                      className="w-16 h-16 text-neuro-cyan/60 group-hover:text-neuro-cyan transition-colors"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M12 14c-5 0-8 2.5-8 5v2h16v-2c0-2.5-3-5-8-5z" />
                    </svg>
                    <div className="absolute inset-0 bg-neuro-cyan/0 group-hover:bg-neuro-cyan/10 transition-all duration-300"></div>
                  </div>
                </div>
                <div className="text-center">
                  <div className="flex justify-center mb-2 text-neuro-cyan group-hover:scale-110 transition-transform">
                    <DesignIcon />
                  </div>
                  <p className="text-sm text-gray-400 group-hover:text-neuro-cyan transition-colors">
                    {t("howItWorks.participants.design")}
                  </p>
                </div>
              </div>
            </div>

            <svg
              className="absolute top-32 left-0 w-full h-64 pointer-events-none opacity-40"
              style={{ zIndex: 0 }}
            >
              <line
                x1="20%"
                y1="0"
                x2="50%"
                y2="100%"
                stroke="url(#gradient1)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
              />
              <line
                x1="40%"
                y1="0"
                x2="50%"
                y2="100%"
                stroke="url(#gradient2)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
                style={{ animationDelay: "0.5s" }}
              />
              <line
                x1="60%"
                y1="0"
                x2="50%"
                y2="100%"
                stroke="url(#gradient3)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
                style={{ animationDelay: "1s" }}
              />
              <line
                x1="80%"
                y1="0"
                x2="50%"
                y2="100%"
                stroke="url(#gradient4)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
                style={{ animationDelay: "1.5s" }}
              />
              <defs>
                <linearGradient
                  id="gradient1"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#00F5D4" stopOpacity="0.8" />
                  <stop offset="100%" stopColor="#00F5D4" stopOpacity="0.2" />
                </linearGradient>
                <linearGradient
                  id="gradient2"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#8A2EFF" stopOpacity="0.8" />
                  <stop offset="100%" stopColor="#8A2EFF" stopOpacity="0.2" />
                </linearGradient>
                <linearGradient
                  id="gradient3"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#4FE1FF" stopOpacity="0.8" />
                  <stop offset="100%" stopColor="#4FE1FF" stopOpacity="0.2" />
                </linearGradient>
                <linearGradient
                  id="gradient4"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#00F5D4" stopOpacity="0.8" />
                  <stop offset="100%" stopColor="#00F5D4" stopOpacity="0.2" />
                </linearGradient>
              </defs>
            </svg>

            <div
              className="flex justify-center mb-16 relative z-10 animate-float"
              style={{ animationDelay: "0.25s" }}
            >
              <div className="group cursor-pointer relative w-48 h-48">
                <svg
                  className="absolute inset-0 w-full h-full animate-spin-slow"
                  viewBox="0 0 100 115"
                  fill="none"
                >
                  <path
                    d="M50 0 L100 28.75 L100 86.25 L50 115 L0 86.25 L0 28.75 Z"
                    className="stroke-neuro-cyan/40"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
                <svg
                  className="absolute inset-0 w-full h-full"
                  viewBox="0 0 100 115"
                  fill="none"
                >
                  <path
                    d="M50 0 L100 28.75 L100 86.25 L50 115 L0 86.25 L0 28.75 Z"
                    className="stroke-neuro-azure/70 group-hover:stroke-neuro-azure transition-colors duration-500"
                    strokeWidth="4"
                    fill="none"
                  />
                </svg>
                <div className="hexagon-large w-48 h-48 bg-linear-to-br from-neuro-cyan/10 to-neuro-purple/10 flex items-center justify-center relative overflow-hidden backdrop-blur-md shadow-[0_0_50px_rgba(79,225,255,0.4),inset_0_0_50px_rgba(0,245,212,0.15)] group-hover:shadow-[0_0_80px_rgba(79,225,255,0.6),inset_0_0_80px_rgba(0,245,212,0.25)] transition-all duration-500 animate-hex-glow">
                  <div className="text-neuro-azure group-hover:scale-110 transition-transform duration-300">
                    <CentralNeuralIcon />
                  </div>
                </div>
                <p className="text-center mt-4 text-sm font-semibold gradient-text">
                  {t("howItWorks.collective.title")}
                </p>
              </div>
            </div>

            <svg
              className="absolute bottom-32 left-0 w-full h-64 pointer-events-none opacity-40"
              style={{ zIndex: 0 }}
            >
              <line
                x1="50%"
                y1="0"
                x2="20%"
                y2="100%"
                stroke="url(#gradient5)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
              />
              <line
                x1="50%"
                y1="0"
                x2="40%"
                y2="100%"
                stroke="url(#gradient6)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
                style={{ animationDelay: "0.5s" }}
              />
              <line
                x1="50%"
                y1="0"
                x2="60%"
                y2="100%"
                stroke="url(#gradient7)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
                style={{ animationDelay: "1s" }}
              />
              <line
                x1="50%"
                y1="0"
                x2="80%"
                y2="100%"
                stroke="url(#gradient8)"
                strokeWidth="2"
                strokeDasharray="5,5"
                className="animate-pulse"
                style={{ animationDelay: "1.5s" }}
              />
              <defs>
                <linearGradient
                  id="gradient5"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#00F5D4" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#00F5D4" stopOpacity="0.8" />
                </linearGradient>
                <linearGradient
                  id="gradient6"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#8A2EFF" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#8A2EFF" stopOpacity="0.8" />
                </linearGradient>
                <linearGradient
                  id="gradient7"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#4FE1FF" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#4FE1FF" stopOpacity="0.8" />
                </linearGradient>
                <linearGradient
                  id="gradient8"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#00F5D4" stopOpacity="0.2" />
                  <stop offset="100%" stopColor="#00F5D4" stopOpacity="0.8" />
                </linearGradient>
              </defs>
            </svg>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {/* Stage 1 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "0.2s" }}
              >
                <div className="relative w-32 h-32 mb-4">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 70 80"
                    fill="none"
                  >
                    <path
                      d="M35 0 L70 20 L70 60 L35 80 L0 60 L0 20 Z"
                      className="stroke-neuro-cyan/50 group-hover:stroke-neuro-cyan transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon w-32 h-32 bg-gradient-to-br from-neuro-cyan/10 to-neuro-cyan/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(0,245,212,0.5),inset_0_0_30px_rgba(0,245,212,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(0,245,212,0.2)] backdrop-blur-sm">
                    <div className="text-neuro-cyan group-hover:scale-110 transition-transform">
                      <RocketIcon />
                    </div>
                    <div className="absolute inset-0 bg-neuro-cyan/0 group-hover:bg-neuro-cyan/10 transition-all duration-300"></div>
                  </div>
                </div>
                <p className="text-center text-sm font-semibold text-gray-300 group-hover:text-neuro-cyan transition-colors uppercase tracking-wider">
                  {t("howItWorks.stages.concept")}
                </p>
              </div>

              {/* Stage 2 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "0.7s" }}
              >
                <div className="relative w-32 h-32 mb-4">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 70 80"
                    fill="none"
                  >
                    <path
                      d="M35 0 L70 20 L70 60 L35 80 L0 60 L0 20 Z"
                      className="stroke-neuro-purple/50 group-hover:stroke-neuro-purple transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon w-32 h-32 bg-gradient-to-br from-neuro-purple/10 to-neuro-purple/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(138,46,255,0.5),inset_0_0_30px_rgba(138,46,255,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(138,46,255,0.2)] backdrop-blur-sm">
                    <div className="text-neuro-purple group-hover:scale-110 transition-transform">
                      <DrawingIcon />
                    </div>
                    <div className="absolute inset-0 bg-neuro-purple/0 group-hover:bg-neuro-purple/10 transition-all duration-300"></div>
                  </div>
                </div>
                <p className="text-center text-sm font-semibold text-gray-300 group-hover:text-neuro-purple transition-colors uppercase tracking-wider">
                  {t("howItWorks.stages.drawings")}
                </p>
              </div>

              {/* Stage 3 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "1.2s" }}
              >
                <div className="relative w-32 h-32 mb-4">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 70 80"
                    fill="none"
                  >
                    <path
                      d="M35 0 L70 20 L70 60 L35 80 L0 60 L0 20 Z"
                      className="stroke-neuro-azure/50 group-hover:stroke-neuro-azure transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon w-32 h-32 bg-gradient-to-br from-neuro-azure/10 to-neuro-azure/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(79,225,255,0.5),inset_0_0_30px_rgba(79,225,255,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(79,225,255,0.2)] backdrop-blur-sm">
                    <div className="text-neuro-azure group-hover:scale-110 transition-transform">
                      <ChartIcon />
                    </div>
                    <div className="absolute inset-0 bg-neuro-azure/0 group-hover:bg-neuro-azure/10 transition-all duration-300"></div>
                  </div>
                </div>
                <p className="text-center text-sm font-semibold text-gray-300 group-hover:text-neuro-azure transition-colors uppercase tracking-wider">
                  {t("howItWorks.stages.plans")}
                </p>
              </div>

              {/* Stage 4 */}
              <div
                className="flex flex-col items-center group cursor-pointer animate-float"
                style={{ animationDelay: "1.7s" }}
              >
                <div className="relative w-32 h-32 mb-4">
                  <svg
                    className="absolute inset-0 w-full h-full"
                    viewBox="0 0 70 80"
                    fill="none"
                  >
                    <path
                      d="M35 0 L70 20 L70 60 L35 80 L0 60 L0 20 Z"
                      className="stroke-neuro-cyan/50 group-hover:stroke-neuro-cyan transition-colors duration-500"
                      strokeWidth="4"
                      fill="none"
                    />
                  </svg>
                  <div className="hexagon w-32 h-32 bg-gradient-to-br from-neuro-cyan/10 to-neuro-cyan/5 flex items-center justify-center relative overflow-hidden group-hover:shadow-[0_0_30px_rgba(0,245,212,0.5),inset_0_0_30px_rgba(0,245,212,0.1)] transition-all duration-500 shadow-[0_0_20px_rgba(0,245,212,0.2)] backdrop-blur-sm">
                    <div className="text-neuro-cyan group-hover:scale-110 transition-transform">
                      <DocIcon />
                    </div>
                    <div className="absolute inset-0 bg-neuro-cyan/0 group-hover:bg-neuro-cyan/10 transition-all duration-300"></div>
                  </div>
                </div>
                <p className="text-center text-sm font-semibold text-gray-300 group-hover:text-neuro-cyan transition-colors uppercase tracking-wider">
                  {t("howItWorks.stages.documentation")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
